import { z } from 'zod';

export const ParsedDate = z.preprocess(
    (x) => (x instanceof Date ? x : typeof x === 'string' || typeof x === 'number' ? new Date(x) : x),
    z.date(),
);
